import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import TransactionForm from "../../components/TransactionForm";

const AdminTransactionNewPage = () => {
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(
			`${t("modules.transaction.header.new.title")} | ${t("lib:go_component.navigation.admin")}`
		);
	}, []);

	return (
		<div className="content">
			<Header title={t("modules.transaction.header.new.title")} />
			<TransactionForm />
		</div>
	);
};

export default AdminTransactionNewPage;
